import React from 'react';
import {
    DashboardOutlined,
    PeopleOutlined,
    LocalHospitalOutlined,
    SettingsOutlined,
    MedicalServicesOutlined,
    EventOutlined,
    EmojiEventsOutlined,
    BuildOutlined,
    DescriptionOutlined,
    ChatOutlined,
    MedicationOutlined,
    BedroomParentOutlined,
    CalendarMonthOutlined
} from '@mui/icons-material';

export const getMenuItems = (t) => {
    const base = process.env.REACT_APP_BASE_PATH || '/dashboard';
    const mk = (p) => {
        // Extract only the parts after the base path
        const fullPath = (p || '').split('/').filter(Boolean);
        const baseParts = (base || '').split('/').filter(Boolean);
        
        // If path is exactly the base, it's the dashboard
        if (fullPath.join('/') === baseParts.join('/')) return 'dashboard';
        
        // Otherwise, get the last segment (the actual route)
        const routeParts = fullPath.slice(baseParts.length);
        return routeParts.length > 0 ? routeParts[routeParts.length - 1] : 'dashboard';
    };
    return [
        {
            text: t("menu.dashboard"),
            icon: <DashboardOutlined />,
            path: `${base}`,
            key: 'dashboard', // Hardcoded to ensure it's always 'dashboard'
        },
        {
            text: t("menu.residents"),
            icon: <PeopleOutlined />,
            path: `${base}/elderly`,
            key: mk(`${base}/elderly`),
        },
        {
            text: t("menu.medicines"),
            icon: <MedicationOutlined />,
            path: `${base}/medicines`,
            key: mk(`${base}/medicines`),
        },
        {
            text: t("menu.nurses"),
            icon: <LocalHospitalOutlined />,
            path: `${base}/nurses`,
            key: mk(`${base}/nurses`),
        },
        {
            text: t("menu.doctors"),
            icon: <MedicalServicesOutlined />,
            path: `${base}/doctors`,
            key: mk(`${base}/doctors`),
        },
        {
            text: t("menu.rooms"),
            icon: <BedroomParentOutlined />,
            path: `${base}/rooms`,
            key: mk(`${base}/rooms`),
        },
        {
            text: t("menu.appointments"),
            icon: <EventOutlined />,
            path: `${base}/appointments`,
            key: mk(`${base}/appointments`),
        },
        {
            text: t("menu.events"),
            icon: <EmojiEventsOutlined />,
            path: `${base}/events`,
            key: mk(`${base}/events`),
        },
        {
            text: t("menu.calendar"),
            icon: <CalendarMonthOutlined />,
            path: `${base}/calendar`,
            key: mk(`${base}/calendar`),
        },
        {
            text: t("menu.maintenance"),
            icon: <BuildOutlined />,
            path: `${base}/maintenance`,
            key: mk(`${base}/maintenance`),
        },
        {
            text: t("menu.documents"),
            icon: <DescriptionOutlined />,
            path: `${base}/documents`,
            key: mk(`${base}/documents`),
        },
        {
            text: t("menu.contacts"),
            icon: <ChatOutlined />,
            path: `${base}/contacts`,
            key: mk(`${base}/contacts`),
        },
        {
            text: t("menu.settings"),
            icon: <SettingsOutlined />,
            path: `${base}/settings`,
            key: mk(`${base}/settings`),
        },
    ];
};

export default getMenuItems;
